<template>
	<b-modal
		:hide-footer="true"
		:no-close-on-backdrop="true"
		:title="loading ? '' : titulo"
		centered
		size="lg"
		@hidden="cancelar"
		id="modal-remanejar-acompanhamento"
	>
		<div class="row" v-if="loading">
			<h1 class="col-12 text-center">{{ msg }}</h1>
			<load mode="table" />
		</div>
		<div v-else>
			<div class="row px-3" v-if="tecnicosTemp.length > 0">
				<form-input-group
					class="px-0"
					type="search"
					v-model="search"
					btn-class="btn input-group-text border-left-0 p-2 bg-white"
					icon-btn="mdi mdi-magnify mdi-18px"
					placeholder="Filtrar pelo técnico"
				/>
			</div>
			<div class="row px-1 mb-3" v-if="tecnicos.length > 0">
				<div class="table-tecnicos col-12">
					<table class="b-table table table-striped table-sm b-table-stacked-md">
						<thead>
							<tr>
								<th></th>
								<th>Nome</th>
								<th>Unidade</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="tecnico in filtrarResultados" :key="tecnico.id">
								<td>
									<input
										type="radio"
										:id="tecnico.id"
										:value="tecnico.id"
										v-model="novo_responsavel"
									/>
								</td>
								<td>
									 <strong>{{ tecnico.value }}</strong> - <span> {{ tecnico.profissao ?? 'Não informado' }} </span>
								</td>
								<td>
									<span>
										{{ tecnico.nome_unidade }} 
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-12 p-0">
					<form-textarea
						v-model="motivo"
						:required="true"
						label="Motivo do remanejamento"
					/>
				</div>
			</div>
			<div v-else>
				<h2 class="text-warning">
					<i class="mdi mdi-24px mdi-alert-decagram-outline"></i> Nada foi encontrado.
				</h2>
			</div>
			<div class="row pt-1 px-2 d-flex justify-content-end">
				<button
					v-if="novo_responsavel"
					@click="submit"
					class="btn btn-success btn-submit"
				>
					Remanejar
				</button>
				<button class="btn btn-danger" @click="cancelar">
					<i class="mdi mdi-close"></i> {{ tecnicos.length > 0 ? "Cancelar" : "Fechar" }}
				</button>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	props: ["acompanhamento", "tecnico"],
	data() {
		return {
			titulo: "Selecione para quem será remanejado o(s) acompanhamento(s)",
			loading: true,
			tecnicos: [],
			tecnicosTemp: [],
			novo_responsavel: "",
			msg: "Buscando técnicos.",
			search: "",
			motivo: "",
		};
	},
	mounted() {
		// this.getTecnicos();
	},
	watch: {
		acompanhamento() {
			this.getTecnicos();
		},
		tecnico() {
			// this.titulo = "Selecione para quem será remanejado o(s) acompanhamento(s)";
			this.getTecnicos();
		},
	},
	computed: {
		// sortedRows() {
		// 	return this.tecnicos.filter((row, index) => {
		// 		return index;
		// 	});
		// },
		filtrarResultados() {
			if (this.search != "") {
				return this.tecnicos.filter((item) => {
					const nome = item.value.toLowerCase();
					const unidade = item.nome_unidade.toLowerCase();
					const busca = this.search.toLowerCase();
					const tecnico = nome.includes(busca);
					if (tecnico) {
						return item;
					} else {
						return unidade.includes(busca) ? item : false;
					}
				});
			} else {
				return this.tecnicos;
			}
		},
	},
	methods: {
		submit() {
			if (this.motivo == null || this.motivo == "") {
				swal.fire({
					text: "Preencha o motivo do remanejamento para continuar.",
					icon: "warning",
					showConfirmButton: false,
					timer: 3000,
				});
			} else {
				this.loading = true;
				this.msg = "Remanejando";
				axios
					.post(`api/dashboard/acompanhamento/remanejar`, {
						paf_id: this.acompanhamento ? this.acompanhamento.id : null,
						novo_responsavel: this.novo_responsavel,
						motivo: this.motivo,
						tecnico_origem: this.tecnico ? (this.tecnico.id || this.tecnico) : null,
					})
					.then((response) => {
						swal.fire({
							text: "Remanejado com sucesso.",
							icon: "success",
							showConfirmButton: false,
							timer: 3000,
						});
						this.tecnico ? this.cancelar() : this.redirectAcompanhamentos();
						this.loading = false;
						this.$emit("limpar");
					})
					.catch((error) => {
						swal.fire({
							text: "Não foi possível remanejar para o técnico selecionado.",
							icon: "error",
							showConfirmButton: false,
							timer: 3000,
						});
						this.loading = false;
					});
			}
		},
		getTecnicos() {
			this.loading = true;
			var id = "";
			if (this.acompanhamento) {
				id = this.acompanhamento.responsavel.tecnico.id;
			} else {
				id = this.tecnico && (this.tecnico.id || this.tecnico);
			}
			if (id > 0) {
				axios
          .get(`api/dashboard/acompanhamento/exclude/tecnicos/${id}`)
					.then((response) => {
						this.tecnicos = response.data;
						this.tecnicosTemp = response.data;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		redirectAcompanhamentos() {
			this.$router.push(`/dashboard/acompanhamentos/${this.acompanhamento.familia_id.id}?familia_id=${this.acompanhamento.familia_id.id}`);
		},
		cancelar() {
			this.$bvModal.hide("modal-remanejar-acompanhamento");
			this.$emit("limpar");
		},
	},
};
</script>
<style lang="css">
.table-tecnicos {
	max-height: 50vh !important;
	overflow: auto !important;
}
</style>
